// extracted by mini-css-extract-plugin
export default {"payment_page":"PaymentPage_payment_page__e1MU6","subscription_details":"PaymentPage_subscription_details__A2qkD","initiate_payment_btn":"PaymentPage_initiate_payment_btn__teqb7"};